import { useFormat } from '@ideavivat/vivat-2';

import { toCommaFormat } from '@/utils';

export const _increment = {
  name: 'ลำดับ',
  width: '3rem',
  class: 'text-center',
};

export const _deliveredControls = {
  name: 'การส่ง',
  width: '3.5rem',
  class: 'text-center',
};

export const code = {
  name: 'รหัสสินค้า',
  width: '8rem',
  class: 'text-center',
};

export const name = {
  name: 'ชื่อสินค้า | ปริมาตร(กxยxส)',
  width: '15rem',
};

export const count = {
  name: 'จำนวน',
  width: '4rem',
  class: {
    cell: 'text-center',
    text: 'text-right',
  },
  filter: (val: string) => toCommaFormat(val || 0, 0, 2),
};

export const unit = {
  name: 'หน่วย',
  width: '5rem',
  class: {
    cell: 'text-left',
    text: 'text-left',
  },
};

export const totalWeight = {
  name: 'น้ำหนัก (กก.)',
  class: {
    cell: 'text-center',
    text: 'text-right',
  },
  width: '6rem',
  filter: (val: string) => toCommaFormat(val, 2, 2),
};

export const deliveryFeeRate = {
  name: 'ค่าจัดส่ง/หน่วย (บาท)',
  width: '8rem',
  filter: (val: string, row: any) => toCommaFormat(row.item.deliveryFee / row.item.count, 2, 2),
  class: {
    cell: 'text-center',
    text: 'text-right',
  },
};

export const deliveryFee = {
  name: 'ค่าจัดส่ง (บาท)',
  width: '5rem',
  class: {
    cell: 'text-center',
    text: 'text-right',
  },
  filter: (val: string) => useFormat.number(val).currency(),
};

export const _remarksControls = {
  name: 'หมายเหตุ',
  width: '12rem',
  class: {
    cell: 'text-center',
    text: 'text-right',
  },
};
